import React from 'react';

const AlertIcon = () => {
  return <div className="ip-alert-icon"></div>;
};

export default AlertIcon;
